export default "__VITE_ASSET__e70e52bb__"